import { useCallback, useState } from "react";
import { STATUS } from "react-joyride";

// One "seen" flag per tool, so finishing one tour never hides another.
export const TOURS = {
    VTON: "VTON_JOYRIDE_STATUS",
    REIMAGINE: "REIMAGINEAI_JOYRIDE_STATUS",
    GENERATE: "GENERATE_JOYRIDE_STATUS",
    MODEL_GENERATOR: "MODEL_GENERATOR_JOYRIDE_STATUS",
    MODEL_SWAP: "MODEL_SWAP_JOYRIDE_STATUS",
    STUDIO: "STUDIO_JOYRIDE_STATUS",
};

export const TOUR_KEYS = Object.values(TOURS);

// The shape every tour shares, so they look and behave alike.
export const TOUR_PROPS = {
    continuous: true,
    showProgress: true,
    showSkipButton: true,
    scrollToFirstStep: true,
    locale: { back: "Back", last: "Done", next: "Next", skip: "Skip" },
};

// Joyride only reads "no beacon" per step, so every step gets it here.
export const withoutBeacon = (steps) => steps.map((step) => ({ disableBeacon: true, ...step }));

export function isTourDone(key) {
    try {
        return localStorage.getItem(key) === "finished";
    } catch {
        return false;
    }
}

export function resetTours() {
    try {
        TOUR_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch {
        // Storage may be unavailable; nothing to reset.
    }
}

/**
 * Whether a tour should run, and the Joyride callback that records it as seen.
 * Finishing or skipping both count: someone who skipped does not want it back on the next visit.
 */
export function useTour(key) {
    const [done, setDone] = useState(() => isTourDone(key));
    const onCallback = useCallback(({ status }) => {
        if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
            try {
                localStorage.setItem(key, "finished");
            } catch {
                // Storage may be unavailable; the tour just shows again next time.
            }
            setDone(true);
        }
    }, [key]);
    return { done, onCallback };
}
